export const HISTORY_ENTRY_REMOVED_EVENT = 'asi:history-entry-removed';
